import {
  SlIcon
} from "./chunk.YHLNUJ7P.js";

// src/components/icon/icon.ts
var icon_default = SlIcon;
SlIcon.define("sl-icon");

export {
  icon_default
};
